const { cELM, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class CreditCardInput {
  constructor(data) {
    this.data = data;
    this.element = cELM("div", "option-block");
    this.__elements = null;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;
    const inputContainer = cELM("div", "inputs-wrapper");
    const row1 = cELM("div", "row");
    const row2 = cELM("div", "row");
    const row3 = cELM("div", "row");
    const row4 = cELM("div", "row");
    const row5 = cELM("div", "row");

    const labelText = (this.data || {}).label;
    const labelSpan = cELM('span', 'credit-card-form-label', labelText || "Credit Card");
    row1.addELM(labelSpan);

    const errMsg = cELM("div", "notification-message", "");
    errMsg.style.display = "none";

    const nameEl = cELM("input", "text-input");
    const numberEl = cELM("input", "text-input");
    const monthEl = cELM("input", "text-input");
    const yearEl = cELM("input", "text-input");
    const cvvEl = cELM("input", "text-input");

    const addressEl = cELM("input", "text-input");
    const zipEl = cELM("input", "text-input");

    nameEl.placeholder = (this.data || {}).name || "Name on Card";
    numberEl.placeholder = (this.data || {}).number || "Credit Card Number";
    monthEl.placeholder = (this.data || {}).exp_month || "Month";
    yearEl.placeholder = (this.data || {}).exp_year || "Year";
    cvvEl.placeholder = (this.data || {}).cvc || "CVV";
    addressEl.placeholder = (this.data || {}).address || "Address";
    zipEl.placeholder = (this.data || {}).zip || "Zip";

    // AR: TODO the max / min doesn't work for number type
    yearEl.type = "number";
    yearEl.pattern = "[0-9]*";
    yearEl.min = "2019";
    yearEl.max = "2050";
    yearEl.setAttribute('inputmode',"numeric");

    monthEl.maxLength = "4";
    monthEl.type = "number";
    monthEl.pattern = "[0-9]*";
    monthEl.min = "1";
    monthEl.max = "12";
    monthEl.maxLength = "2";
    monthEl.setAttribute('inputmode',"numeric");

    //<input class="InputElement is-invalid Input" autocomplete="cc-number" autocorrect="off" spellcheck="false" name="cardnumber" inputmode="numeric" aria-label="Credit or debit card number" placeholder="Card number" aria-invalid="true" value="4444 4444 4444 44">
    numberEl.setAttribute('inputmode',"numeric");
    numberEl.type = "text";
    numberEl.pattern = "[0-9]*";
    numberEl.maxLength = "22";

    cvvEl.type = "number";
    cvvEl.maxLength = "4";
    cvvEl.minLength = "3";
    cvvEl.setAttribute('inputmode',"numeric");
    cvvEl.style['-webkit-text-security'] = 'disc';

    zipEl.type = "number";
    zipEl.maxLength = "5";
    zipEl.setAttribute('inputmode',"numeric");

    let values = (this.data || {}).values,
    _skip = "Cancel";

    if (values) {
      let valueSplit = values.split('|');

      if (valueSplit[0]) {
        _skip = valueSplit[0];
      }

      if (valueSplit[1]) {
        this._continue = valueSplit[1];
        this._errorContinue = valueSplit[1];
      }

      if (valueSplit[2]) {
        this._errorContinue = valueSplit[2];
      }
    }

    const buttonEl = cELM("div", "continue-button", (this._continue || getLngTxt("button.continue")));
    const skipEl = cELM("div", "continue-button skip-button", _skip); //AR: don't highlight skip to encourge ppl enter cc

    if (this.data.storedCard && this.data.storedCard.name) {
      nameEl.value = (this.data.storedCard.name || "");
      numberEl.value = (this.data.storedCard.number || "");
      monthEl.value = (this.data.storedCard.month || "");
      yearEl.value = (this.data.storedCard.year || "");
      cvvEl.value = (this.data.storedCard.cvv || "");
      addressEl.value = (this.data.storedCard.address || "");
      zipEl.value = (this.data.storedCard.zipcode || "");

      nameEl.setAttribute("disabled", true);
      numberEl.setAttribute("disabled", true);
      monthEl.setAttribute("disabled", true);
      yearEl.setAttribute("disabled", true);
      cvvEl.setAttribute("disabled", true);
      addressEl.setAttribute("disabled", true);
      zipEl.setAttribute("disabled", true);

      buttonEl.classList.add("continue-button-active");
    }

    skipEl.onclick = function(evt) {
      buttonEl.classList.remove("continue-button-active");
      buttonEl.parentNode.point(false);

      Chat.default.send({
          text: "skip",
          id: _self.data.id
        }, 
        null, 
        _self.element
      );
    };

    buttonEl.onclick = function(evt) {
      if(buttonEl.className.indexOf('continue-button-active') === -1) {
        return;
      }

      errMsg.style.display = "none";

      nameEl.classList.remove("invalid");
      numberEl.classList.remove("invalid");
      yearEl.classList.remove("invalid");
      monthEl.classList.remove("invalid");
      cvvEl.classList.remove("invalid");
      addressEl.classList.remove("invalid");
      zipEl.classList.remove("invalid");

      if (
        nameEl.value &&
        numberEl.value &&
        monthEl.value &&
        yearEl.value &&
        cvvEl.value &&
        addressEl.value &&
        zipEl.value
      ) {

        if (_self.isFormValid()) {
          const ccNumber = numberEl.value.split(" ").join("");

          let month = monthEl.value;
          if(month.length == 1){
            month = '0'+month;
          }
          let year = yearEl.value;
          if(year.length == 2){
            year = '20'+year;
          }

          let op = {
            cvc: cvvEl.value,
            name: nameEl.value,
            number: ccNumber,
            exp_month: monthEl.value,
            exp_year: yearEl.value,
            address_line1: addressEl.value,
            address_zip: zipEl.value,
          };

          op.transactionId = ((_self || {}).data || {}).transactionId;

          nameEl.blur();
          numberEl.blur();
          yearEl.blur();
          monthEl.blur();
          cvvEl.blur();
          addressEl.blur();
          zipEl.blur();

          buttonEl.innerText = ((_self || {}).data || {}).validatingText || "Validating...";
          buttonEl.classList.remove("continue-button-active");
          buttonEl.parentNode.point(false);

          Chat.default.send({
              text: op,
              id: _self.data.id
            }, 
            null, 
            _self.element
          );
        } else {

          for (var index = 0; index < _self.__order.length; index++) {
            if(_self.__order[index].classList.contains('not-valid')){
              _self.__order[index].parentNode.point(true);
              break;
            }
          }

          errMsg.style.display = "block";
          errMsg.innerHTML = ((_self || {}).data || {}).enterValidValue || "Please enter a valid value";
        }
      } else {

        for (var index = 0; index < _self.__order.length; index++) {
          if(_self.__order[index].value.length == 0){
            _self.__order[index].parentNode.point(true);
            break;
          }
        }

        errMsg.style.display = "block";
        errMsg.innerHTML = ((_self || {}).data || {}).enterValidValueEmpty || "Please enter valid values in the missing field.";
      }
    };


    function validateForm() {
      if (_self.isFormValid(false)) {
        buttonEl.classList.add("continue-button-active");
        buttonEl.parentNode.point(true);
          
      }
    }


    zipEl.onkeyup = function(evt) {

      if(zipEl.value.length > 5){
        zipEl.value = zipEl.value.substring(0,5);
        _self.isFormValid(false);
      }
    };

    monthEl.onkeyup = function(evt){
      if(monthEl.value.length > 2){
        monthEl.value = monthEl.value.substring(0,2);
        _self.isFormValid(false);
      }
    }
    yearEl.onkeyup = function(evt){
      if(yearEl.value.length > 4){
        yearEl.value = yearEl.value.substring(0,4);
        _self.isFormValid(false);
      }
    }

    cvvEl.onkeyup = function(evt){
      if(cvvEl.value.length > 4){
        cvvEl.value = cvvEl.value.substring(0,4);
        _self.isFormValid(false);
      }
    }

    numberEl.onkeyup = function(evt) {
      let onlyNumber = evt.target.value.split(" ").join("");
      // replace all hyphen without using regexp
      onlyNumber = onlyNumber.replace(/\D/g,'');

      let out = "";
      for (var i = 0; i < onlyNumber.length; i++) {
        if (i > 1 && i % 4 === 0 && i < 16) {
          out += " ";
        }
        out += onlyNumber[i].toString();
      }

      evt.target.value = out;
    };


    nameEl.oninput = validateForm;
    numberEl.oninput = validateForm;
    monthEl.oninput = validateForm;
    yearEl.oninput = validateForm;
    cvvEl.oninput = validateForm;
    addressEl.oninput = validateForm;
    zipEl.oninput = validateForm;

    inputContainer.addELM(row1);
    inputContainer.addELM(row2);
    inputContainer.addELM(row3);
    inputContainer.addELM(row4);

    if (this.data.storedCard && this.data.storedCard.name) {
      row1.addELM(Wrap4Arrow(nameEl, false,true));
    } else {
      row1.addELM(Wrap4Arrow(nameEl, true,true));
    }
    row2.addELM(Wrap4Arrow(numberEl, false,true));
    row3.addELM(Wrap4Arrow(monthEl, false,true));
    row3.addELM(Wrap4Arrow(yearEl, false,true));
    row3.addELM(Wrap4Arrow(cvvEl, false,true));
    row4.addELM(Wrap4Arrow(addressEl, false,true));
    row4.addELM(Wrap4Arrow(zipEl, false,true));
    this.element.addELM(inputContainer);
    this.element.addELM(errMsg);

    inputContainer.addELM(row5);
    row5.classList.add('button-row');
    row5.addELM(skipEl);
    if (this.data.storedCard && this.data.storedCard.name) {
      row5.addELM(Wrap4Arrow(buttonEl, true, true));
    } else {
      row5.addELM(Wrap4Arrow(buttonEl));
    }
    
    this.__elements = {
      nameEl,
      numberEl,
      monthEl,
      yearEl,
      cvvEl,
      addressEl,
      zipEl,
      errMsg,
      buttonEl,
    };

    this.__order = [nameEl, numberEl, monthEl, yearEl, cvvEl, addressEl, zipEl];
    this.setFocusTimeout();

    return this.element;
  }

  handleOnError(error, transactionId, activeContinueButton = true) {
    this.__elements.errMsg.style.display = "block";
    this.__elements.errMsg.innerHTML = error;

    if (error.indexOf("Card") > -1) {
      this.__elements.numberEl.classList.add("invalid");
    }

    if (activeContinueButton) {
      this.__elements.buttonEl.classList.add("continue-button-active");
    }

    if (transactionId) {
      this.data.transactionId = transactionId;
    }

    this.__elements.buttonEl.innerText = (this._continue || "Continue");
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.nameEl.value = "";
    this.__elements.numberEl.value = "";
    this.__elements.monthEl.value = "";
    this.__elements.yearEl.value = "";
    this.__elements.cvvEl.value = "";
    this.__elements.addressEl.value = "";
    this.__elements.zipEl.value = "";
    //this.__elements.nameEl.focus();
  }

  focus() {
    //this.__elements.nameEl.focus();
  }

  setFocusTimeout() {


    var _context = this;

    var setBlur = (evt) => {
        evt.target.parentNode.point(false);
        focusNext(evt,true);
    }

    var focusNext = (evt,disableFocus) => { //look for next field that is not valid format
      var el = evt.target;
      var currentIndex = _context.__order.indexOf(el);
      var nextIndex = (currentIndex + 1) % _context.__order.length;
      var nextInvalidElement = _context.__order[nextIndex];


      if(el.value.length > 0 && nextInvalidElement.value.length == 0 && !el.classList.contains('not-valid')){
        if(!disableFocus)      
          nextInvalidElement.focus();
        if(nextInvalidElement.parentNode.point){
          nextInvalidElement.parentNode.point(true);
        }

      }

    }

    var setIntervalFocus = (evt) => {

      if (evt.target.timer) {
        clearTimeout(evt.target.timer);
      }
  
      if (evt.key === "Enter" || evt.keyCode === "13") {
        evt.target.blur();
        focusNext(evt)
      }
      else
      {
        evt.target.timer = setTimeout(function () {

          focusNext(evt)

        }, 3000);          
      }



    };
    for (var index = 0; index < this.__order.length; index++) {
      this.__order[index].onkeydown = setIntervalFocus;
      this.__order[index].onblur = setBlur;
    }
  }

  isFormValid() {
    let isValid = true;
    const ccNumber = this.__elements.numberEl.value.split(" ").join("");

    if (!this.__elements.nameEl.value && this.__elements.nameEl.value) {
      isValid = false;
      this.__elements.nameEl.classList.add("not-valid");
    } else {
      this.__elements.nameEl.classList.remove("not-valid");
    }

    if ((ccNumber.length < 15 || ccNumber.length > 19) && ccNumber.length > 0) {
      isValid = false;
      this.__elements.numberEl.classList.add("not-valid");
    } else {
      this.__elements.numberEl.classList.remove("not-valid");
    }

    if ((this.__elements.yearEl.value.length !== 2 && this.__elements.yearEl.value.length !== 4) && this.__elements.yearEl.value.length > 0) {
      isValid = false;
      this.__elements.yearEl.classList.add("not-valid");
    } else {
      this.__elements.yearEl.classList.remove("not-valid");
    }

    if ((Number(this.__elements.monthEl.value) > 12) && this.__elements.monthEl.value.length > 0) {
      isValid = false;
      this.__elements.monthEl.classList.add("not-valid");
    } else {
      this.__elements.monthEl.classList.remove("not-valid");
    }


    if ((!this.__elements.cvvEl.value || (this.__elements.cvvEl.value.length !== 3 && this.__elements.cvvEl.value.length !== 4)) && this.__elements.cvvEl.value.length > 0) {
      isValid = false;
      this.__elements.cvvEl.classList.add("not-valid");
    } else {
      this.__elements.cvvEl.classList.remove("not-valid");
    }

    if (!this.__elements.addressEl.value && this.__elements.addressEl.value.length > 0) {
      isValid = false;
      this.__elements.addressEl.classList.add("not-valid");
    } else {
      this.__elements.addressEl.classList.remove("not-valid");
    }

    if ((!this.__elements.zipEl.value || this.__elements.zipEl.value.length !== 5) && this.__elements.zipEl.value.length > 0) {
      isValid = false;
      this.__elements.zipEl.classList.add("not-valid");
    } else {
      this.__elements.zipEl.parentNode.point(false);
      this.__elements.zipEl.classList.remove("not-valid");
    }

    if(isValid && (
       this.__elements.nameEl.value.length === 0
       || ccNumber.length === 0
       || this.__elements.monthEl.value.length === 0
       || this.__elements.yearEl.value.length === 0
       || this.__elements.cvvEl.value.length === 0
       || this.__elements.zipEl.value.length  === 0       
       ))
    {
      isValid = false;
    }
    
    return isValid;
  }
}

module.exports = CreditCardInput;
